<template>
	<div>
		<div class="multiple">
			<div class="child-div">数据分发设置</div>
		  <RadioGroup v-model="dispense_set">
		          <Radio label="平均分配"></Radio>
		          <Radio label="智能分配"></Radio>
		  </RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">智能分配规则</div>
		  <RadioGroup v-model="intelligent">
		          <Radio label="上门"></Radio>
		          <Radio label="签约"></Radio>
		  </RadioGroup>
		</div>
	</div>
</template>

<script>
	export default{
		name:'DataSet',
		data() {
			return {
				dispense_set:'平均分配',
				intelligent:'上门'
			}
		},
	}
</script>

<style scoped lang="less">
	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;
	
		.child-div {
			width: 90px;
			height: 20px;
			margin-right: 30px;
			font-weight: bold;
			text-align-last: justify;
		}
	}
	/deep/ .ivu-table table {
		width: 100% !important;
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
	
	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
